import axiosInstance from './axios.service';
const axios = axiosInstance;

class TicketService {
  async getPorcentajeTicketsVendidos(rifaId) {
    const { data } = await axios.get(`/api/tickets/porcentajeTicketsVendidos/${rifaId}`);
    return data;
  }

  async getTickets(rifaId) {
    const { data } = await axios.get(`/api/tickets/${rifaId}`);
    return data;
  }

  async createTicket(ticket) {
    const { data } = await axios.post('/api/tickets', ticket);
    return data;
  }

  async updateTicket(ticketId, ticket) {
    const { data } = await axios.put(`/api/tickets/${ticketId}`, ticket);
    return data;
  }

  async deleteTicket(ticketId) {
    const { data } = await axios.delete(`/api/tickets/${ticketId}`);
    return data;
  }

  async getTicketsByRifa(rifaId /*, skip, limit*/) {
    const { data } = await axios.get(`/api/tickets/ticketsByRifa/${rifaId}`);
    return data;
  }

  async getAvailableTicketsPaginated(rifaId, skip, limit, search = '') {
    const params = search ? { q: search } : {};
    const { data } = await axios.get(`/api/tickets/disponiblesRifa/${rifaId}/${skip}/${limit}`, {
      params,
    });
    return data;
  }

  async getRifaTicketStats(rifaId) {
    const { data } = await axios.get(`/api/tickets/statsRifa/${rifaId}`);
    return data;
  }

  async pickRandomAvailableTickets(rifaId, count) {
    const { data } = await axios.post(`/api/tickets/randomDisponibles/${rifaId}`, { count });
    return data;
  }

  async getTicketsByVendedor(vendedorId, skip, limit) {
    const { data } = await axios.get(`/api/tickets/vendedor/${vendedorId}/${skip}/${limit}`);
    return data;
  }

  async getTicketsByComprador(compradorId, skip, limit) {
    const { data } = await axios.get(`/api/tickets/comprador/${compradorId}/${skip}/${limit}`);
    return data;
  }

  async getTicketsByRifaAndType(rifaId, type, skip, limit) {
    const { data } = await axios.get(`/api/tickets/rifa/${rifaId}/byType/${type}/${skip}/${limit}`);
    return data;
  }

  async freezeTicket(id) {
    const { data } = await axios.put(`/api/tickets/congelarTicket/${id}`);
    return data;
  }

  async unfreezeTicket(id) {
    const { data } = await axios.put(`/api/tickets/descongelarTicket/${id}`);
    return data;
  }

  async freezeRange(rifaId, from, to) {
    const { data } = await axios.put(`/api/tickets/congelarRango/${rifaId}`, { from, to });
    return data;
  }

  async unfreezeRange(rifaId, from, to) {
    const { data } = await axios.put(`/api/tickets/descongelarRango/${rifaId}`, { from, to });
    return data;
  }

  async reserveTicket(id, reservationData) {
    const { data } = await axios.put(`/api/tickets/${id}/reserve`, reservationData);
    return data;
  }

  async confirmTicketPayment(id) {
    const { data } = await axios.put(`/api/tickets/${id}/confirm-payment`);
    return data;
  }

  async downloadExcel() {
    const { data } = await axios.get('/api/tickets/exportExcel', {
      responseType: 'arraybuffer',
    });
    return data;
  }

  /**
   * Returns all tickets for a raffle (_id, nroSerial, estado).
   * Used by the board raffle number picker to show available / taken numbers.
   */
  async getAllByRifa(rifaId) {
    const { data } = await axios.get(`/api/tickets/allByRifa/${rifaId}`);
    return data;
  }

  async lookupTicket(id) {
    const { data } = await axios.get(`/api/tickets/lookup/${id}`);
    return data;
  }

  async redeemTicket(id) {
    const { data } = await axios.post(`/api/tickets/redeem/${id}`);
    return data;
  }
}

export default new TicketService();
